/* bf26y-autobag.js (r7). Plain carts reaching the first ladder rung (3 pieces) get exactly one free wash bag.
   Event driven off the ladder engine (no polling). The bag is $0 through the existing Free Washbag discount.
   r10 (13 Oct): ONE wash bag only. Auto-added bags (properties _bf_auto, _bf_free or _bf_set) are trimmed to a single unit, dropped when the customer holds their own bag, and removed below 3 pieces. Bags without those properties (customer choice) are never removed.
   r10b (13 Oct): the retry guard (lastTry) is reset on every cart change that leaves fewer than 3 pieces, so removing an item and adding it back brings the bag back even when the bag was removed by hand in between. Also loads assets/bf26y-r10.js (display clean-ups).
   r16 (13 Oct): also loads assets/bf26y-giftguard.js (own cache token ?v=r16b: bump it when that file changes), which now enforces the rungs for the bag and the mystery gift (refuses un-earned adds, removes un-earned bag and gift lines, including manual ones). Below 3 pieces act() now removes every bag line, not only auto-added ones. Backup: bf26y-autobag-bak-20261013-r16.js
   r53 (15 Oct): the bag add itself moved to assets/bf26y-giftguard.js (see the note above the r7 block); this file keeps the loaders, the one-bag guard and r7 / r9.
   r18 (13 Oct): fixes the double wash bag race on PDP pack adds. The theme's own pack add posts the pieces and then a second add for the bag; the auto-bag add used to land in between. Now (1) act() waits while a product form / quick add click is in flight (hold, 4s after the click, re-checked afterwards) and (2) the bag add re-reads /cart.js right before posting and is skipped if any bag line exists. Backup: bf26y-autobag-bak-20261013-r18.js */
/* r8: the offer pills (bf26y-perks) must show on every card type everywhere (search, product page recommendations, cart drawer recs on any page).
   snippets/bf26z-sitewide.liquid only loads them on collections, home, cart, sets and builder, so load them here for every other template (same asset URL, same version). */
(function () {
  var me = document.querySelector('script[src*="bf26y-autobag.js"]');
  if (me && !document.querySelector('script[src*="bf26y-r10.js"]')) {
    var r = document.createElement('script');
    r.src = me.src.replace('bf26y-autobag.js', 'bf26y-r10.js'); r.defer = true;
    document.head.appendChild(r);
  }
  if (me && !document.querySelector('script[src*="bf26y-giftguard.js"]')) {
    var g = document.createElement('script');
    g.src = me.src.split('?')[0].replace('bf26y-autobag.js', 'bf26y-giftguard.js') + '?v=r53'; g.defer = true;
    document.head.appendChild(g);
  }
  if (document.querySelector('script[src*="bf26y-perks.js"]')) return;
  if (!me) return;
  var l = document.createElement('link'), s = document.createElement('script');
  l.rel = 'stylesheet'; l.href = me.src.replace('bf26y-autobag.js', 'bf26y-perks.css');
  s.src = me.src.replace('bf26y-autobag.js', 'bf26y-perks.js'); s.defer = true;
  document.head.appendChild(l); document.head.appendChild(s);
})();

/* r10: one wash bag only. A multi-item JSON cart/add.js (a set, the RKKN Set page) that carries a wash bag is sent without it when the cart already holds one,
   and a second bag inside the same call is dropped. Bag-only adds (the customer choosing a bag) pass untouched. Non-JSON bodies (native product forms) are not touched. */
(function () {
  if (window.__bf26BagGuard || !window.fetch) return;
  window.__bf26BagGuard = 1;
  var of = window.fetch.bind(window), ids = null;
  function bagIds() {
    return ids || (ids = of('/products/wash-bag.js').then(function (r) { return r.json(); }).then(function (p) { return p.variants.map(function (v) { return Number(v.id); }); }).catch(function () { return []; }));
  }
  window.fetch = function (u, o) {
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url) || !o || typeof o.body !== 'string' || o.body.charAt(0) !== '{') return of(u, o);
      var b = JSON.parse(o.body);
      if (!b.items || b.items.length < 2) return of(u, o);
      if (b.items.every(function (i) { return i.properties && i.properties._bf_auto; })) return of(u, o); // r53: the gift sync's own bag + gift add (already checked)
      return Promise.all([bagIds(), of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })]).then(function (x) {
        var has = (x[1].items || []).some(function (i) { return x[0].indexOf(Number(i.variant_id)) > -1; }), seen = false;
        var keep = b.items.filter(function (i) { if (x[0].indexOf(Number(i.id)) < 0) return true; if (has || seen) return false; seen = true; return true; });
        if (keep.length && keep.length !== b.items.length) { b.items = keep; o = Object.assign({}, o, { body: JSON.stringify(b) }); }
        return of(u, o);
      }).catch(function () { return of(u, o); });
    } catch (e) { return of(u, o); }
  };
})();

/* r53 (15 Oct 2026): the automatic wash bag add / trim that lived here (act, addBag, a 4 s hold, then a #CartDrawer swap or a full page reload on /cart) moved to
   assets/bf26y-giftguard.js: ONE cart sync adds and removes the free bag and the mystery gift right after the cart goes quiet and re-renders the drawer
   from the same response. Nothing here adds a bag any more. */

/* r7: Sets page quick view (bf26s-qv.js) has no product page link. Add "View full details" under the Add button, same markup/class as the Bundle Builder quick view (.bbu-qv__full).
   Event driven: armed by a click on a tile image or name, then watches only the quick view body (direct children), never the document. */
(function () {
  var h = '';
  function put(body) {
    var ctl = body.querySelector('.bbu-qv__ctl');
    if (!ctl || !h || body.querySelector('.bbu-qv__full')) return;
    var a = document.createElement('a');
    a.className = 'bbu-qv__full';
    a.href = '/products/' + encodeURIComponent(h);
    a.textContent = 'View full details';
    ctl.parentNode.insertBefore(a, ctl.nextSibling);
  }
  document.addEventListener('click', function (e) {
    var t = e.target, q = t && t.closest && t.closest('.bbu-qv-m, .bbu-qv-t'), c = q && q.closest('[data-bb-card]');
    if (!c || !document.querySelector('[data-bs-set]')) return;
    h = c.getAttribute('data-handle') || '';
    setTimeout(function () {
      var body = document.querySelector('[data-bbu-body]');
      if (!body) return;
      put(body);
      if (!body.__bf26yFull) {
        body.__bf26yFull = 1;
        new MutationObserver(function () { put(body); }).observe(body, { childList: true });
      }
    }, 0);
  }, true);
})();

/* r9: hover image for product-linked tiles that are not native cards (homepage tiles whose link goes to a product page). Same crossfade as the cards (see bf26q-card.css). Hover-capable devices only; the second photo is looked up once the tile is near the viewport, so nothing loads on phones. Tiles that link to a collection or page are editorial and stay as they are. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover)').matches || !('IntersectionObserver' in window)) return;
  function arm(card) {
    var a = card.querySelector('a[href*="/products/"]'), wrap = card.querySelector('.multicolumn-card__image-wrapper .media');
    if (!a || !wrap || wrap.querySelector('[data-bf26q-img="hover"]')) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    if (!m) return;
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var md = (p.media || []).filter(function (x) { return x.media_type === 'image'; })[1];
        if (!md || !md.src) return;
        var im = document.createElement('img');
        im.className = 'bf26y-hov';
        im.setAttribute('data-bf26q-img', 'hover');
        im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
        im.src = md.src + (md.src.indexOf('?') > -1 ? '&' : '?') + 'width=710';
        im.onerror = function () { im.remove(); };
        wrap.appendChild(im);
      }).catch(function () {});
    }, { rootMargin: '300px' });
    io.observe(card);
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('.multicolumn-card'), arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
